import React, { useState } from "react";
import search from "../library/svg/search.svg";

const Search = ({ callbackFunction }) => { // Accept the callback as a prop
  const [searchKeyword, setSearchKeyword] = useState("");


  const handleChange = (event) => {
    setSearchKeyword(event.target.value);
  };

  const handleSearch = (event) => {
    event.preventDefault();
    const trimmedKeyword = searchKeyword.trim();
    if (trimmedKeyword) {
      // Call the callback function with the trimmed keyword
      callbackFunction(trimmedKeyword);
      // navigate(`/search?query=${encodeURIComponent(trimmedKeyword)}`);
    }
  };

  return (
    <section className="body search-body">
      <div className="search-container">
        <form className="search-bar" onSubmit={handleSearch}>
          <div className="es-input-text search-term">
            <input
              id="searchKeyword"
              type="text"
              name="searchKeyword"
              placeholder="&nbsp;"
              onChange={handleChange}
              value={searchKeyword}
            />
            <label htmlFor="searchKeyword" className="search-label">
              Search books by title, keyword, ISBN & author
            </label>
            <button type="submit" className="search-button">
              <img src={search} alt="search" />
            </button>
          </div>
        </form>
      </div>
    </section>
  );
};

export default Search;